import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { BRAND } from "@/lib/site";
import { TESTIDS } from "@/constants/testIds/site";

export const FinalCTA = ({
  title = "Ready to see the building?",
  subtitle = "Tour the lobby, the conference floors, and a suite that fits your team — usually within 48 hours.",
}) => {
  return (
    <section
      data-testid={TESTIDS.finalCta}
      className="bg-[var(--primary)] text-white grain"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-end">
          <div className="md:col-span-8">
            <div className="eyebrow-light">A final invitation</div>
            <h2 className="section-title text-white text-[44px] md:text-[68px] mt-4 leading-[1.02] max-w-3xl">
              {title}
            </h2>
            <p className="mt-6 text-[16px] md:text-[17px] text-white/75 max-w-xl leading-relaxed">
              {subtitle}
            </p>
          </div>
          <div className="md:col-span-4 flex flex-col gap-3">
            <Link to="/contact" className="btn-bright justify-center">
              Schedule a tour
              <ArrowRight size={14} strokeWidth={2.5} />
            </Link>
            <a
              href={`tel:${BRAND.phoneRaw}`}
              className="text-white/85 text-[14px] inline-flex items-center justify-center gap-2 py-3 hover:text-white"
            >
              <Phone size={14} strokeWidth={1.6} />
              or call {BRAND.phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
